// Props para una fila de tabla clickeable (patrón de ESTANDAR-UI §7): sin
// esto, la fila solo se abre con mouse. Agrega foco de teclado y Enter/Espacio
// como atajo del click, sin tocar el `role="row"` implícito de la fila.
export function filaClickeable(onActivar) {
  return {
    onClick: onActivar,
    tabIndex: 0,
    onKeyDown: (e) => {
      // Si el Enter/Espacio vino de un botón u otro control adentro de la
      // fila (ej. editar/eliminar), ese control ya resuelve su propia
      // acción: no hay que disparar también la de la fila.
      if (e.target !== e.currentTarget) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onActivar(e); }
    }
  };
}

export const FOCO_FILA = 'focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-turquoise-400';
